import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EndpointService } from '@app/core';
import { ModeloBase } from '@app/shared';
import { environment } from '@env/environment';

@Injectable()
export class HeaderDescriptionTaskDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Actualiza la fecha de activacion y finalizacion de una tarea en especifico
   *
   * @param {number} idTask
   * @param {Date} dateInit
   * @param {Date} dateFinish
   * @returns {Observable<boolean>}
   * @memberof HeaderDescriptionTaskDataService
   */
  setDateInitAndFinish(idTask: number, dateInit: Date | string, dateFinish: Date | string): Observable<boolean> {
    return new Observable(obs => {
      if (dateInit) {
        let dateInitFormat: Date;
        let dateFinishFormat: Date;
        if (typeof dateInit === 'string') {
          dateInitFormat = new Date(dateInit);
        } else {
          dateInitFormat = dateInit;
        }
        if (typeof dateFinish === 'string') {
          dateFinishFormat = new Date(dateFinish);
        } else {
          dateFinishFormat = dateFinish;
        }
        const formData = {
          fecha_activacion: dateInitFormat.toLocaleDateString() + ' ' + dateInitFormat.toLocaleTimeString('es', { hour12: false }),
          fecha_finalizacion: ''
        };
        if (dateFinish) {
          // tslint:disable-next-line: max-line-length
          formData['fecha_finalizacion'] = dateFinishFormat.toLocaleDateString() + ' ' + dateFinishFormat.toLocaleTimeString('es', { hour12: false });
        }
        this.http
          .put<ModeloBase[]>(this.api.get('taskSpecialOptions', [idTask]), formData).subscribe(
            _res => {
              obs.next(true);
            },
            err => {
              obs.error(err);
            }
          );
      } else {
        this.toastr.error('Se produjo un error al realizar la petición al servidor.', 'Ocurrió un error');
        obs.next(false);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-description-task/shared/header-description-task.data.service.ts